/**
 * Entities API Module
 * Handles entity CRUD operations and searches
 * Part of API optimization - follows AIM atomicity principle
 */

import { api } from './client'
import { realtimeClient } from '../apiClient'

export const entityAPI = {
  getEntities: (params) => api.get('/entities', { params }),
  getEntity: (id) => api.get(`/entities/${id}`),
  createEntity: (data) => api.post('/entities', data),
  updateEntity: (id, data) => api.put(`/entities/${id}`, data),
  deleteEntity: (id) => api.delete(`/entities/${id}`),
  getEntityLocations: (id, params, headers) => api.get(`/entities/${id}/locations`, { params, headers }),
  getEntityGallery: (id) => {
    // Note: Caching is now handled by galleryCache service
    // This method should only be called through the cache service
    return api.get(`/entities/${id}/gallery`)
  },
  searchEntities: (query) => api.get('/entities', { params: { search: query } }),
  getCategories: () => api.get('/categories'),
  getEntityChannel: (id) => api.get(`/entities/${id}/channel`),
  getFeaturedEntity: () => {
    const params = import.meta.env.DEV ? { _t: Date.now() } : {} // Cache buster only in dev
    return api.get('/entities/featured', { params })
  },
  claimEntity: (id) => api.post(`/entities/${id}/claim`),
  getCityLandingPage: (slug) => api.get(`/cities/${slug}`),
  getEntityTrustStats: (id) => api.get(`/entities/${id}/trust-stats`),
  getEntitySightingPatterns: (id, tz) => api.get(`/entities/${id}/sighting-patterns`, tz ? { params: { tz } } : undefined),
}

// Location API - uses realtime client for map updates
export const locationAPI = {
  getNearbyEntities: (params) => realtimeClient.get('/locations', { params }),
  getNearbyEntitiesWithHistory: (params, headers) => realtimeClient.get('/locations/nearby-history', { params, headers }),
  searchEntities: (params) => api.get('/locations/search', { params })
}
